import { mapContentBlocks, SharingEvent } from '@news-mono/web-common'
import React, { FC } from 'react'
import { Logger } from 'typescript-log'
import { ArticleBlockContent } from '../../ArticleBlockContent/ArticleBlockContent'
import { Byline } from '../../Byline/Byline'
import { PublishedLiveEventPost } from '../helpers'
import { getPinnedChipType } from '../helpers/get-pinned-type'
import {
    StyledLiveEventArticleBlockContent,
    StyledLiveEventPost,
    StyledLiveEventSocialIcons,
    StyledLiveEventTitle,
} from './LiveEventPost.styled'

export interface LiveEventPostProps {
    post: PublishedLiveEventPost
    eventTitle: string
    log: Logger
    adUnitPath: string
    lazyLoadRef?: React.RefObject<HTMLDivElement>
    onEvent: (event: SharingEvent) => void
    /** Build event post with an id attribute for deeplinking
     * @default true
     */
    renderIDAnchorTag?: boolean
    /** Element is located inside a truncating container and overflowing */
    canTruncate?: boolean
    isActivePost?: boolean
    entryType?: string
}

export const LiveEventPost: FC<LiveEventPostProps> = ({
    post,
    eventTitle,
    log,
    adUnitPath,
    lazyLoadRef,
    onEvent,
    renderIDAnchorTag = true,
    canTruncate,
    isActivePost,
    entryType,
}) => {
    const authorName =
        post.profiles.length >= 1
            ? post.profiles.map((profile) => profile.name).join(' &')
            : post.byline

    const pinnedVariant = getPinnedChipType(post.sticky, canTruncate)

    return (
        <StyledLiveEventPost
            ref={lazyLoadRef}
            key={post.id}
            id={renderIDAnchorTag ? post.id : undefined}
            noBotMargin={canTruncate}
            isActivePost={isActivePost}
        >
            <Byline
                profile={post.profiles}
                publicationKind={post.kind}
                timestamp={post.publishedDate}
                isFullWidth={true} //
                allowCommenting={false}
                fundingType={undefined}
                text={authorName || undefined}
                happeningPost={post.happening?.label}
                pinnedPost={pinnedVariant}
                entryType={entryType}
            ></Byline>
            {post.title && (
                <StyledLiveEventTitle>{post.title}</StyledLiveEventTitle>
            )}
            <StyledLiveEventArticleBlockContent>
                <ArticleBlockContent
                    blocks={mapContentBlocks(post.content.blocks)}
                    onEvent={() => {}}
                    log={log}
                    adUnitPath={adUnitPath}
                    publicationKind={'event'}
                />
            </StyledLiveEventArticleBlockContent>
            <StyledLiveEventSocialIcons
                url={post._self}
                text={post.title || eventTitle}
                onEvent={onEvent}
                shareOptions={['twitter', 'facebook', 'clipboard']}
                customCampaign="liveblog"
                publicationId={post.eventId}
                postId={post.id}
            />
        </StyledLiveEventPost>
    )
}
